import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { Agent, AgentClient, DocumentTypeClient, DocumentTypes, TipAvaria, TipAvariaClient, Unit, VIKUnitClient } from "src/app/web-api-client";

@Component({
  selector: 'app-avarii-type-edit',
  templateUrl: './avarii-type-edit.component.html',
  styleUrls: ['./avarii-type-edit.component.scss']
})
export class AvariiTypeEditComponent implements OnInit {


  public onClose = new Subject<boolean>();
  public isLoaded = true;
  public editObject: TipAvaria;

  Form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, private toastr: ToastrService, public client: TipAvariaClient) { }

  ngOnInit(): void {

    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {


      this.editObject.title = this.Form.value.title;
      this.editObject.isActive = this.Form.value.isActive;




      this.client.update(this.editObject).subscribe((user) => {

        this.toastr.success("Успешно Редактиране", "Тип Аварии", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
